import React, { createRef, useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";
import "cropperjs/dist/cropper.css";
import { getDashboardData, getGroups, getUser } from "../services/adminServices";
import { Link } from "react-router-dom";
import { checkPermission } from "../helper/helper";

const Dashboard = () => {
  const { login, appData } = useContext(AppContext);
  const [dashboard, setDashboard] = useState({});
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);

  const getDashboardStats = async () => {
    try {
      let result = await getDashboardData(login.token);
      setDashboard(result.data)
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const getGroupsData = async () => {
    let result = await getGroups(login.token, { limit: 5, page: 1 });
    setGroups(result.data)
  }

  const getUsersData = async () => {
    let result = await getUser(login.token, { limit: 5, page: 1 });
    setUsers(result.data)
  }

  useEffect(() => {
    getDashboardStats()
    getGroupsData()
    getUsersData()
  }, []);

  function formatMB(mb) {
    const sizes = ["MB", "GB", "TB"];
    let i = 0;
    let size = mb;

    while (size >= 1024 && i < sizes.length - 1) {
      size /= 1024;
      i++;
    }

    return (size?.toFixed(2) || "0") + " " + sizes[i];
  }

  return (
    <div className="container">
      <div className="menuCard">
        <div className="row g-4">
          <div className="col-xl-3 col-md-6">
            <div className="menuCard-wrapper">
              <div className="pageName d_flex">
                <h4 className="fs-32">Users</h4>
                {checkPermission(login.user, "usergroup:create_update") && <a href="#users">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.4017 36L12 34.5983L32.5233 14.0359H13.6052V12H36V34.3948H33.9641V15.4767L13.4017 36Z" fill="#FFBD38" />
                  </svg>
                </a>}
              </div>
              <div className="supportNumber d_flex">
                <h2>{dashboard.totalUsers}</h2>
                <i class="fas fa-user" style={{ fontSize: "58px",color:"#ffbd38" }}></i>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6">
            <div className="menuCard-wrapper">
              <div className="pageName d_flex">
                <h4 className="fs-32">Groups</h4>
                {checkPermission(login.user, "usergroup:create_update") && <a href="#groups">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.4017 36L12 34.5983L32.5233 14.0359H13.6052V12H36V34.3948H33.9641V15.4767L13.4017 36Z" fill="#FF475A" />
                  </svg>
                </a>}
              </div>
              <div className="supportNumber d_flex">
                <h2>{dashboard.totalGroups}</h2>
                <i class="fas fa-users" style={{ fontSize: "58px",color:'#ff475a' }}></i>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6">
            <div className="menuCard-wrapper">
              <div className="pageName d_flex">
                <h4 className="fs-32">Storage</h4>
                <a href="#">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.4017 36L12 34.5983L32.5233 14.0359H13.6052V12H36V34.3948H33.9641V15.4767L13.4017 36Z" fill="#1EDD60" />
                  </svg>
                </a>
              </div>
              <div className="supportNumber d_flex">
                <h2>{formatMB(dashboard.dataSize)}</h2>
                <i class="fa-solid fa-server" style={{ fontSize: "58px",color:"#1EDD60" }} aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6">
            <div className="menuCard-wrapper">
              <div className="pageName d_flex">
                <h4 className="fs-32">Announcement</h4>
                <a href="#">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.4017 36L12 34.5983L32.5233 14.0359H13.6052V12H36V34.3948H33.9641V15.4767L13.4017 36Z" fill="#9F47FF" />
                  </svg>
                </a>
              </div>
              <div className="supportNumber d_flex">
                {/* <h2>6</h2> */}
                <h5>Comming Soon</h5>
                <i class="fa-solid fa-bullhorn" style={{ fontSize: "58px",color:'#9f47ff' }} aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dataWrapper">
        <div className="row g-3">
          {groups.length > 0 && <div className="col-xl-6">
            <div className="tableData">
              <div className="tableTitle d_flex">
                <h4 className="fs-20">
                  <i class="fas fa-users" style={{ fontSize: "30px",color:"#ff475a" }}></i> &nbsp; Group List
                </h4>
                <div className="site-btn">
                  <Link to="/groups">More info
                    <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.4017 36L12 34.5983L32.5233 14.0359H13.6052V12H36V34.3948H33.9641V15.4767L13.4017 36Z" fill="#051143"></path>
                    </svg>
                  </Link>
                </div>
              </div>
              <div className="dataList">
                <table>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Group Name</th>
                      <th>Group Members</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      groups.map((x, i) => {
                        return (
                          <tr key={i}>
                            <td>{i + 1}.</td>
                            <td>{x.name}</td>
                            <td>{x.members.length}</td>
                            <td>{x.isDeleted ? "Disabled" : "Enabled"}</td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>}
          <div className="col-xl-6">
            <div className="tableData">
              <div className="tableTitle d_flex">
                <h4 className="fs-20">
                <i class="fa-solid fa-server" style={{ fontSize: "30px",color:"#1edd60" }} aria-hidden="true"></i> &nbsp; Storage
                </h4>
                <div className="site-btn">
                  <a className="redBg" href="#">More info
                    <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.4017 36L12 34.5983L32.5233 14.0359H13.6052V12H36V34.3948H33.9641V15.4767L13.4017 36Z" fill="#051143"></path>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="dataList">
                <table>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Type</th>
                      <th>Size</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboard?.dataSizeStats?.map((x, i) => (
                      <tr key={i}>
                        <td>{i + 1}.</td>
                        <td>{x.type}</td>
                        <td>{x.sizeMB} MB</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* <div className="col-xl-6">
            <div className="tableData">
              <div className="tableTitle d_flex">
                <h4 className="fs-20">
                  <svg width="30" height="30" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M41.0833 44.5394H31.4166L20.6624 51.6926C19.0674 52.7559 16.9166 51.6202 16.9166 49.6869V44.5394C9.66665 44.5394 4.83331 39.706 4.83331 32.456V17.9559C4.83331 10.7059 9.66665 5.87256 16.9166 5.87256H41.0833C48.3333 5.87256 53.1666 10.7059 53.1666 17.9559V32.456C53.1666 39.706 48.3333 44.5394 41.0833 44.5394Z" fill="#1EDD60"></path>
                    <path d="M29 27.4534V26.946C29 25.3026 30.0151 24.4326 31.0301 23.7318C32.0209 23.0551 33.0116 22.1851 33.0116 20.5901C33.0116 18.3668 31.2233 16.5784 29 16.5784C26.7767 16.5784 24.9884 18.3668 24.9884 20.5901" stroke="#DCFCE7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"></path>
                    <path d="M28.9891 33.2291H29.0109" stroke="#DCFCE7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"></path>
                  </svg>Last login time
                </h4>
                <div className="site-btn">
                  <a className="greenBg" href="#">More info
                    <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.4017 36L12 34.5983L32.5233 14.0359H13.6052V12H36V34.3948H33.9641V15.4767L13.4017 36Z" fill="#051143"></path>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="dataList">
                <table>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Support id</th>
                      <th>Subject</th>
                      <th>Created By</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1.</td>
                      <td>T0000001</td>
                      <td>mayank@gmail.com</td>
                      <td>Mayank</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>T0000001</td>
                      <td>mayank@gmail.com</td>
                      <td>Mayank</td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>T0000001</td>
                      <td>mayank@gmail.com</td>
                      <td>Mayank</td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>T0000001</td>
                      <td>mayank@gmail.com</td>
                      <td>Mayank</td>
                    </tr>
                    <tr>
                      <td>5.</td>
                      <td>T0000001</td>
                      <td>mayank@gmail.com</td>
                      <td>Mayank</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div> */}
          {/* <div className="col-xl-6">
            <div className="tableData">
              <div className="tableTitle d_flex">
                <h4 className="fs-20">
                  <svg width="30" height="30" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M31.2046 30.5408H25.9191C21.6086 30.5408 17.4748 32.2531 14.4269 35.301C11.3789 38.3489 9.66663 42.4828 9.66663 46.7932V49.4289C9.66663 50.7408 10.1878 51.9989 11.1154 52.9266C12.043 53.8542 13.3012 54.3753 14.613 54.3753H42.5107C43.8225 54.3753 45.0807 53.8542 46.0083 52.9266C46.9359 51.9989 47.4571 50.7408 47.4571 49.4289V46.7932C47.4571 42.4828 45.7448 38.3489 42.6968 35.301C39.6489 32.2531 35.515 30.5408 31.2046 30.5408Z" fill="#9F47FF"></path>
                    <path d="M28.5619 28.4418C30.7773 28.4418 32.943 27.7848 34.785 26.5538C36.627 25.3228 38.0625 23.5732 38.91 21.5262C39.7575 19.4793 39.9789 17.227 39.5462 15.0542C39.1135 12.8814 38.0461 10.8857 36.479 9.31967C34.9119 7.7536 32.9156 6.68746 30.7426 6.2561C28.5695 5.82474 26.3173 6.04755 24.2709 6.89634C22.2245 7.74512 20.4758 9.18176 19.2459 11.0245C18.0161 12.8673 17.3604 15.0334 17.3618 17.2489C17.3674 20.2169 18.5495 23.0617 20.6489 25.1598C22.7483 27.2579 25.5938 28.4381 28.5619 28.4418Z" fill="#9F47FF"></path>
                  </svg>Announcement
                </h4>
                <div className="site-btn">
                  <a className="purpleBg" href="#">More info
                    <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.4017 36L12 34.5983L32.5233 14.0359H13.6052V12H36V34.3948H33.9641V15.4767L13.4017 36Z" fill="#051143"></path>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="dataList">
                <table>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Email Id</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1.</td>
                      <td>Mayank</td>
                      <td>mayank@gmail.com</td>
                    </tr>
                    <tr>
                      <td>2.</td>
                      <td>Mayank</td>
                      <td>mayank@gmail.com</td>
                    </tr>
                    <tr>
                      <td>3.</td>
                      <td>Mayank</td>
                      <td>mayank@gmail.com</td>
                    </tr>
                    <tr>
                      <td>4.</td>
                      <td>Mayank</td>
                      <td>mayank@gmail.com</td>
                    </tr>
                    <tr>
                      <td>5.</td>
                      <td>Mayank</td>
                      <td>mayank@gmail.com</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
